/**
 * @generated SignedSource<<7f9e4ccf1e69ad0b9a0c09a2718f1cbe>>
 * @relayHash 076e5fc491a7f2577f0bf7819e661d59
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 076e5fc491a7f2577f0bf7819e661d59

import { ConcreteRequest } from 'relay-runtime';
export type Ch_markPatientAsPotentialDuplicateInput = {
  patientId: string;
};
export type chMarkPatientAsPotentialDuplicateMutation$variables = {
  input: Ch_markPatientAsPotentialDuplicateInput;
};
export type chMarkPatientAsPotentialDuplicateMutation$data = {
  readonly markPatientAsPotentialDuplicate: {
    readonly boolean: boolean | null;
    readonly errors: ReadonlyArray<{
      readonly __typename: string;
      readonly message?: string;
    }> | null;
  };
};
export type chMarkPatientAsPotentialDuplicateMutation = {
  response: chMarkPatientAsPotentialDuplicateMutation$data;
  variables: chMarkPatientAsPotentialDuplicateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": "markPatientAsPotentialDuplicate",
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "Ch_markPatientAsPotentialDuplicatePayload",
    "kind": "LinkedField",
    "name": "ch_markPatientAsPotentialDuplicate",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "boolean",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": null,
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "message",
                "storageKey": null
              }
            ],
            "type": "Error",
            "abstractKey": "__isError"
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "chMarkPatientAsPotentialDuplicateMutation",
    "selections": (v1/*:: as any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "chMarkPatientAsPotentialDuplicateMutation",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "id": "076e5fc491a7f2577f0bf7819e661d59",
    "metadata": {},
    "name": "chMarkPatientAsPotentialDuplicateMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "02f9b4c873180b4beaf3529da0e772bb";

export default node;
